import React from 'react';
import { AlertCircle, Loader2 } from 'lucide-react';
import { HintsSection } from './HintsSection';
import { Card } from '../ui/Card';
import { HintData, StockData } from '../../types/game';
import { StockCategoryFilter } from '../../types/stockCategories';

interface GameFooterProps {
  processedHints: HintData[];
  visibleHints: number;
  stockData?: StockData | null | undefined;
  currentCategory: StockCategoryFilter;
  hintsLoading: boolean;
  hintsError: string | null;
  className?: string;
  isStreamerMode?: boolean;
}

/**
 * GameFooter component - handles the bottom section
 * Includes hints system and loading/error states for hints
 */
export const GameFooter: React.FC<GameFooterProps> = ({
  processedHints,
  visibleHints,
  stockData,
  currentCategory,
  hintsLoading,
  hintsError,
  className,
  isStreamerMode
}) => {
  return (
    <div className={className}>
      {/* Hints Section */}
      {processedHints.length > 0 && (
        <div className={isStreamerMode ? '' : 'mt-2'}>
          <HintsSection
            hints={processedHints}
            visibleHints={visibleHints}
            stockData={stockData || null}
            category={currentCategory}
            isStreamerMode={isStreamerMode}
          />
        </div>
      )}

      {/* Loading state for hints */}
      {hintsLoading && processedHints.length === 0 && (
        <div className="mt-2">
          <Card className="p-6 text-center">
            <Loader2 className="mx-auto mb-2 animate-spin text-primary" size={24} />
            <p className="text-gray-600 dark:text-gray-400">
              Loading hints...
            </p>
          </Card>
        </div>
      )}

      {/* Error state for hints */}
      {hintsError && !hintsLoading && processedHints.length === 0 && (
        <div className="mt-2">
          <Card className="p-6 text-center border-destructive bg-destructive/10">
            <AlertCircle className="mx-auto mb-2 text-destructive" size={24} />
            <p className="text-destructive font-medium mb-2">
              Unable to load hints
            </p>
            <p className="text-sm text-muted-foreground">
              {hintsError}
            </p>
          </Card>
        </div>
      )}
    </div>
  );
};
